import React from "react";
import ImgSrcBackgroundImageDesktop from "../assets/img/health-support/fastTrackAppointments_2222x1219.jpg";
import ImgSrcBackgroundImageTablet from "../assets/img/health-support/fastTrackAppointments_955x875.jpg";
import ImgSrcBackgroundImageMobile from "../assets/img/health-support/fastTrackAppointments_580x400.jpg";
import styles from "../assets/css/modules/health-support/working-body.css";
import {
  getPhone,
  getPhoneClaims,
  getOpeningHours,
  getOpeningHoursClaims
} from "../helpers/ContentStateHelper";

export default {
  Heading: "Specialist Appointment Booking Service",
  BackgroundDesktopImage: ImgSrcBackgroundImageDesktop,
  BackgroundTabletImage: ImgSrcBackgroundImageTablet,
  BackgroundMobileImage: ImgSrcBackgroundImageMobile,
  HeroContent: (
    <React.Fragment>
      <h1>Specialist Appointment Booking Service</h1>
      <p>
        When you need to see a specialist quickly, our Specialist Appointment Booking Service
        team will make it happen.
      </p>
      <p>
        We'll book you an appointment with the right specialist and at the right
        time for you.
      </p>
      <p>
        To use our Specialist Appointment Booking Service, you just need your GP to
        give you an open referral. This is a referral that doesn’t name a
        specific specialist. Then, give your Personal Advisory team a call who
        will advise you of the next steps:
      </p>
    </React.Fragment>
  ),
  HeroContentPhoneNumbers: {
    International: (props) => (
      <React.Fragment>
        <p className={styles.phoneNumber}>
          <strong>{getPhone(props)}</strong>
        </p>
        <p className={styles.openingHours}>{getOpeningHours(props)}</p>
      </React.Fragment>
    ),
    Saga: (props) => (
      <React.Fragment>
        <p className={styles.phoneNumber}>
          <strong>{getPhone(props)}</strong>
        </p>
        <p className={styles.openingHours}>{getOpeningHours(props)}</p>
      </React.Fragment>
    ),
    Format2: (props) => (
      <React.Fragment>
        <p className={styles.phoneNumber}>
          <strong>{getPhone(props)}</strong>
        </p>
        <p className={styles.openingHours}>{getOpeningHours(props)}</p>
      </React.Fragment>
    ),
    Any: (props) => (
      <React.Fragment>
        <p className={styles.phoneNumber}>
          <strong>{getPhoneClaims(props)}</strong>
        </p>
        <p className={styles.openingHours}>{getOpeningHoursClaims(props)}</p>
      </React.Fragment>
    )
  },
  StepHeader: "How does it work?",
  StepGPReferral: (
    <React.Fragment>
      <h3 className={styles.workingBodyHeading}>
        You’ll need an open GP referral
      </h3>
      <p>
        You just need an open referral from a GP. This is a referral that
        doesn't name the specialist you'll see.
      </p>
    </React.Fragment>
  ),
  StepGiveUsACall: {
    International: (props) => (
      <React.Fragment>
        <h3 className={styles.workingBodyHeading}>Give us a call</h3>
        <p>
          Call us on <strong>{getPhone(props)}</strong>. We'll discuss what you
          need and your availability then coordinate the appointment booking
        </p>
      </React.Fragment>
    ),
    Saga: (props) => (
      <React.Fragment>
        <h3 className={styles.workingBodyHeading}>Give us a call</h3>
        <p>
          Call us on <strong>{getPhone(props)}</strong>. We'll discuss what you
          need and your availability then coordinate the appointment booking
        </p>
      </React.Fragment>
    ),
    Format2: (props) => (
      <React.Fragment>
        <h3 className={styles.workingBodyHeading}>Give us a call</h3>
        <p>
          Call us on <strong>{getPhone(props)}</strong>. We'll discuss what you
          need and your availability then coordinate the appointment booking
        </p>
      </React.Fragment>
    ),
    Any: (props) => (
      <React.Fragment>
        <h3 className={styles.workingBodyHeading}>Give us a call</h3>
        <p>
          Call us on <strong>{getPhoneClaims(props)}</strong>. We'll discuss
          what you need and your availability then coordinate the appointment
          booking
        </p>
      </React.Fragment>
    )
  },
  StepAppointmentBooking: (
    <React.Fragment>
      <h3 className={styles.workingBodyHeading}>Appointment booking</h3>
      <p>
        We'll then book an appointment for you, at a time and a place that suits
        you best. Or, we'll give you a choice of up to three specialists, and
        you can get in touch when you’re ready.
      </p>
    </React.Fragment>
  ),
  HelpSet: [
    {
      Question: "Is the Specialist Appointment Booking Service included as part of my plan?",
      Answer: (
        <React.Fragment>
          <p>
            Yes, we can offer the Specialist Appointment Booking Service providing you have an open
            referral. We can then find you a specialist and even book the
            appointment for you.
          </p>
        </React.Fragment>
      )
    },
    {
      Question: "How do I book a Specialist Appointment?",
      Answer: (
        <React.Fragment>
          <p>
            To book an appointment ask your GP for an open referral (the GP
            doesn't give you a specialist name just the specialism).
          </p>
          <p>
            Then give us a call and we'll book you an appointment, at a time and
            place that suits you. Alternatively we can give you a choice of up
            to three appropriate specialists and you can contact them when you
            want to.
          </p>
        </React.Fragment>
      )
    },
    {
      Question: "Can I change my appointment?",
      Answer: (
        <React.Fragment>
          <p>
            Yes, you can change your appointment by calling us on{" "}
            <strong>0800 092 9668</strong>. Lines are open 8am-6pm
            Monday-Friday.
          </p>
        </React.Fragment>
      )
    }
  ]
};
